import { InvoiceHistory } from './invoicehistory.model';
import { IPatientInvoiceDetail } from './IPatientInvoiceDetail.interface';

export class Invoice {
  number!: string;
  zipCode?: string;
  balanceDue!: number;
  invoiceAmount!: number;
  billingAddress = {} as {
    line1: string;
    line2?: string;
    city: string;
    state: string;
    zipCode: string;
  };
  pid!: string | null;
  specimenNumber!: string;
  dateOfService!: string;
  invoiceDate!: string;
  documentKey?: string | null;
  state?: string;
  patientName?: string;
  patientFirstName?: string;
  patientLastName?: string;
  physicianDetail:
    | {
        firstName: string;
        lastName: string;
        middleName?: string;
        prefix?: string;
        orgName?: string;
        practiceLocationAddress?:
          | {
              line1: string;
              line2?: string;
              city: string;
              state: string;
              zipCode: string;
            }
          | undefined;
      }
    | undefined
    | null;
  totalCharges!: number | null;
  adjustments!: number | null;
  medicarePaid!: number | null;
  medicaidPaid!: number | null;
  insurancePaid!: number | null;
  hasPaymentPlan?: boolean;
  isInPaymentPlan?: boolean;
  patientPaid!: number | null;
  npi?: string | null;
  accessionNumber?: string;
  invoiceHistory?: InvoiceHistory[];
  isPastDue?: boolean;
  encryptedTransactionIds?: string[];
  transactionIds?: string[];
  dunningCycleCode?: string;
  patientDateOfBirth?: string; // Removed from backend response so it won't show up on network
  orderingPhyAccountNumber!: string;
  patientInvoiceDetail?: IPatientInvoiceDetail;
}
